import { z } from 'zod/v4';

import { createLegacyEntitySchema } from '@sites/entity-migrator';

import { textLegacyDefaultV0Schema } from './default';
import { textLegacyZeroV0Schema } from './zero';

/**
 * Discriminated union over the envelope's `type` field. Persisted entities
 * without a `type` field land on the default branch (its `type` literal is
 * `.optional()`); entities tagged `type: 'zero'` land on the zero branch. The
 * two variants diverge only on the inner data's `position` shape.
 */
const textLegacyEntityUnion = z.discriminatedUnion('type', [textLegacyDefaultV0Schema, textLegacyZeroV0Schema]);

export type LegacyTextDefault = z.infer<typeof textLegacyDefaultV0Schema>;
export type LegacyTextZero = z.infer<typeof textLegacyZeroV0Schema>;
export type LegacyText = LegacyTextDefault | LegacyTextZero;

/**
 * Legacy-only entity: the persisted widget shape is the only version (no v0 yet).
 * Single 'web' variant today; the mini-landing shape becomes a second variant
 * when the widget is unified across apps.
 */
export const LegacyTextEntitySchema = createLegacyEntitySchema([{ name: 'web', schema: textLegacyEntityUnion }]);
